export default {
  searchHnNamePhone: 'ค้นหารหัส HN, ชื่อคนไข้, เบอร์โทรศัพท์',
  patient: 'คนไข้',
  addPatient: 'เพิ่มคนไข้ใหม่',
  seePatientInfo: 'ดูข้อมูลคนไข้',
  deleteConfirm: 'ยืนยันการลบคนไข้',
  deleteInfo1: 'คุณกำลังลบคนไข้',
  deleteInfo2: 'ต้องการดำเนินการต่อหรือไม่',
  openOpd: 'เปิด OPD',
  searchPatientName: 'ค้นหาชื่อคนไข้',
  symptom: 'เลือกอาการ',
  title: {
    taxInfo: 'ข้อมูลสำหรับออกใบกำกับภาษี',
    general: 'ข้อมูลทั่วไป',
    healthInfo: 'ข้อมูลสุขภาพ'
  },
  header: {
    historyPill: 'ประวัติการรับยา',
    historyCourse: 'ประวัติการใช้คอร์ส'
  },
  label: {
    peopleId: 'เลขบัตรประจำตัวประชาชน',
    passport: 'เลขที่หนังสือเดินทาง',
    certificateStatement: 'หนังสือรับรองฉบับนี้ ขอรับรองว่า',
    peopleIdPassport: 'เลขบัตรประจำตัวประชาชน/เลขที่หนังสือเดินทาง',
    patientNoRegistered: 'คนไข้ยังไม่ลงทะเบียน',
    name: 'ชื่อผู้ป่วย',
    patientId: 'เลขผู้ป่วย',
    nameEn: 'ชื่อ (EN)',
    nameCn: 'ชื่อ (CN)',
    nickName: 'ชื่อเล่น',
    quantity: 'จำนวนที่เหลือ',
    birthDay: 'วันเกิด',
    detailSendToPatient: 'รายละเอียด (ตั้งค่าให้ส่งหาคนไข้ได้)',
    note: 'หมายเหตุ (ไม่ส่งหาคนไข้)',
    appointDay: 'วันที่นัดหมาย',
    appointmentPerson: 'บุคคลที่นัดหมาย',
    timeStartAppoint: 'เวลาเริ่มนัดหมาย',
    timeEndAppoint: 'เวลาสิ้นสุดนัดหมาย',
    patientArrived: 'ผู้ป่วยมาแล้ว',
    patientArrivedYet: 'ผู้ป่วยยังไม่มา',
    noti: 'การแจ้งเตือน',
    notiFirst: 'แจ้งเตือนก่อน',
    medicalCertificate: 'ใบรับรองแพทย์',
    treatmentCertificate: 'ใบรับรองการรักษา',
    certificateNumber: 'ใบรับรองเลขที่',
    InShort: 'อย่างย่อ',
    selectColor: 'เลือกแถบสี',
    serviceList: 'รายการบริการ',
    serviceListAndCourse: 'รายการบริการและคอร์ส',
    nationality: 'สัญชาติ',
    bloodType: 'กรุ๊ปเลือด',
    rightToTreatment: 'สิทธิการรักษา',
    rightToTreatmentName: 'ชื่อสิทธิการรักษา',
    channelsToKnow: 'ช่องทางที่รู้จักคลินิก',
    contractChanal: 'ช่องทางที่รู้จักคลินิก',
    congenitalDisease: 'โรคประจำตัว',
    accidentAndSurgery: 'อุบัติเหตุ และ ผ่าตัด',
    hospitalized: 'เคยเข้ารับการรักษาในโรงพยาบาล',
    epilepsy: 'โรคลมชัก*',
    leprosyContagiousStage: 'โรคเรื้อนในระยะติดต่อหรือในระยะที่ปรากฏอาการเป็นที่รังเกียจแก่สังคม',
    tuberculosisDangerousStage: 'วัณโรคในระยะอันตราย',
    elephantiasisWithOffensiveSymptoms: 'โรคเท้าช้างในระยะที่ปรากฏอาการเป็นที่รังเกียจต่อสังคม',
    workRelatedDiseaseCheckRequired: 'ถ้าจำเป็นต้องตรวจหาโรคที่เกี่ยวข้องกับการปฏิบัติงานของผู้รับการตรวจให้ระบุข้อนี้',
    personCertification: 'ขอรับรองว่าบุคคลดังกล่าว ไม่เป็นผู้มีร่างกายทุพพลภาพจนไม่สามารถปฏิบัติหน้าที่ได้ไม่ปรากฏอาการของโรคจิต หรือจิตฟั่นเฟือน หรือปัญญาอ่อนไม่ปรากฏอาการของการติดยาเสพติดให้โทษ และอาการของโรคพิษสุราเรื้อรังและไม่ปรากฏอาการและอาการของ โรคต่อไปนี้',
    statementCertification: 'ขอรับรองข้อความข้างต้นนี้เป็นความจริง',
    currentMedicine: 'ยาที่ใช้อยู่',
    allergy: 'แพ้ยา/อาการแพ้',
    subAllergy: 'หมวดหมู่ย่อยของยาที่แพ้',
    patientTag: 'แท็กผู้ป่วย',
    tag: 'แท็ก',
    salesperson: 'พนักงานขายประจำ',
    medicalAssistant: 'ผู้ช่วยแพทย์ประจำ',
    examinedPerson: 'ผู้รับการตรวจ',
    regularDoctor: 'แพทย์ประจำ',
    contact: 'ช่องทางการติดต่อ',
    relation: 'ความสัมพันธ์',
    labelSettings: 'ตั้งค่าฉลาก',
    next: 'ถัดไป',
    back: 'ย้อนกลับ',
    type: 'ประเภทคนไข้',
    editType: 'แก้ไขประเภทคนไข้',
    editTypeInfo: 'แก้ไขข้อมูลประเภทคนไข้',
    editDoctorType: 'แก้ไขข้อมูลประเภทแพทย์',
    enterTypeInfo: 'กรอกข้อมูลประเภทคนไข้',
    statusApp: 'สถานะนัดหมาย',
    normal: 'ปกติ',
    abNormal: 'ไม่ปกติ'
  },
  placeholder: {
    nameCn: 'กรอกชื่อภาษาจีน',
    nickName: 'กรอกชื่อเล่น',
    peopleId: 'กรอกเลขบัตรประจำตัวประชาชน',
    passport: 'กรอกเลขที่หนังสือเดินทาง',
    selectBirthDay: 'เลือกวันเกิด',
    detailSendToPatient: 'รายละเอียด (ตั้งค่าให้ส่งหาคนไข้ได้)',
    note: 'หมายเหตุ (ไม่ส่งหาคนไข้)',
    appointDay: 'วันที่นัดหมาย',
    appointmentPerson: 'บุคคลที่นัดหมาย',
    timeStartAppoint: 'เวลาเริ่มนัดหมาย',
    timeEndAppoint: 'เวลาสิ้นสุดนัดหมาย',
    selectColor: 'เลือกสีที่ต้องการ',
    selectService: 'เลือกบริการ',
    serviceListAndCourse: 'เลือกบริการและคอร์ส',
    nationality: 'กรอกสัญชาติ',
    bloodType: 'เลือกกรุ๊ปเลือด',
    rightToTreatment: 'เลือกสิทธิการรักษา',
    rightToTreatmentName: 'กรอกชื่อสิทธิการรักษา',
    rightToTreatmentInfo: 'กรอกข้อมูลสิทธิการรักษา',
    searchRightToTreatmentName: 'ค้นหาชื่อสิทธิการรักษา',
    channelsToKnow: 'กรอกช่องทางที่รู้จักคลินิก',
    congenitalDisease: 'กรอกโรคประจำตัว',
    currentMedicine: 'กรอกรายละเอียดยา',
    allergy: 'กรอกแพ้ยา/อาการแพ้',
    patientTag: 'กรอกแท็กผู้ป่วย',
    selectPatientTag: 'เลือกแท็กผู้ป่วย',
    salesperson: 'เลือกพนักงานขายประจำ',
    selectPatientType: 'เลือกประเภทคนไข้',
    medicalAssistant: 'เลือกผู้ช่วยแพทย์ประจำ',
    regularDoctor: 'เลือกแพทย์ประจำ',
    contact: 'กรอกช่องทางการติดต่อ',
    enter: 'กรอก',
    relation: 'กรอกความสัมพันธ์',
    searchTag: 'ค้นหาชื่อแท็กคนไข้',
    searchType: 'ค้นหาชื่อประเภทคนไข้'

  },
  status: {
    noti: 'แจ้งเตือน',
    unoti: 'ไม่แจ้งเตือน',
    disableNoti: 'ปิดการแจ้งเตือน',
    activateNoti: 'เปิดการแจ้งเตือน',
    need: 'ต้องการ',
    noneed: 'ไม่ต้องการ',
    haveMedicalCertificate: 'มีใบรับรองแพทย์',
    noHaveMedicalCertificate: 'ไม่มีใบรับรองแพทย์'
  },
  alert: {
    plzEnterTel10: 'โปรดกรอกเบอร์โทรศัพท์ 10 หลัก',
    plzEnterPeopleId: 'โปรดกรอกเลขบัตรประชาชนให้ครบ 13 หลัก',
    plzEnterCorrectPeopleId: 'โปรดกรอกเลขบัตรประชาชนให้ถูกต้อง',
    emailValid: 'กรุณากรอกอีเมลให้ถูกต้อง',
    availableIdUse: 'หมายเลขบัตรประจำตัวประชาชนนี้ถูกใช้งานแล้ว',
    rightToTreatmentDelete: 'ยืนยันการลบสิทธิการรักษา',
    rightToTreatmentConfirm: 'คุณกำลังลบสิทธิการรักษา ต้องการดำเนินการต่อหรือไม่ ?',
    plzPassport: 'โปรดกรอกเลขหนังสือเดินทาง',
    wrongPassport: 'รูปแบบเลขหนังสือเดินทางไม่ถูกต้อง'

  },
  toolTip: {
    patientInfo: 'ข้อมูลคนไข้',
    createPatientInfo: 'สร้างข้อมูลคนไข้',
    createPatientInfoSuc: 'สร้างข้อมูลคนไข้สำเร็จ',
    createRightToTreatment: 'สร้างข้อมูลสิทธิการรักษาคนไข้สำเร็จ !',
    editPatientInfo: 'แก้ไขข้อมูลคนไข้',
    editPatientInfoSuc: 'แก้ไขข้อมูลคนไข้สำเร็จ',
    editRightToTreatment: 'แก้ไขสิทธิการรักษา',
    editRightToTreatmentSuc: 'แก้ไขข้อมูลสิทธิการรักษาคนไข้สำเร็จ !',
    editPatientTag: 'แก้ไขแท็กผู้ป่วย',
    deletePatientInfo: 'ลบข้อมูลคนไข้',
    deletePatientInfoSuc: 'ลบข้อมูลคนไข้สำเร็จ',
    deleteRightToTreatment: 'ลบสิทธิการรักษาสำเร็จ'
  },
  modal: {
    create: {
      tag: {
        success: 'สร้างแท็กคนไข้สำเร็จ !'
      }
    },
    edit: {
      tag: {
        success: 'แก้ไขแท็กสำเร็จ !'
      },
      type: {
        success: 'แก้ไขข้อมูลประเภทคนไข้สำเร็จ !'
      }
    },
    delete: {
      tag: {
        title: 'ยืนยันการลบแท็ก',
        subTitle: 'คุณกำลังลบแท็ก ต้องการดำเนินการต่อหรือไม่ ?',
        success: 'ลบแท็กสำเร็จ !'
      },
      type: {
        title: 'ยืนยันการลบประเภทคนไข้',
        subTitle: 'คุณกำลังลบประเภทคนไข้ ต้องการดำเนินการต่อหรือไม่ ?',
        success: 'ลบประเภทคนไข้สำเร็จ !'
      }
    }
  }
}
